import React from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import {
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import theme from "../../theme";
import "./chartStyles.css";

/**
 * @param {Array}  data         - The data array. Each entry must have `subject` and the data keys. E.g. { subject: "Courtesy", Automated: 85, Manual: 78, fullMark: 100 }
 * @param {String} title        - Chart title
 * @param {Array}  [dataKeys]   - Optional array of data keys to plot multiple radars, e.g. ['Automated','Manual']
 */
const RadarChartComponent = ({ data, title, dataKeys = [] }) => {
  const bgColor = useColorModeValue("chart-box", "chart-box-dark");
  const textColor = useColorModeValue("chart-title", "chart-title-dark");
  
  // Use the same color palette you used in your LineChart
  const chartColors = Object.values(theme.colors.lineChartColors);

  return (
    <Box className={`${bgColor} chart-hover-effect`}>
      <Text mb={3} fontSize="xl" fontWeight="600" color={textColor}>
        {title}
      </Text>
      <Box className="divider" />
      <Box display="flex" flexDirection="column" alignItems="center">
        <ResponsiveContainer width="100%" height={300} minWidth="200px">
          <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
            <PolarGrid />
            <PolarAngleAxis dataKey="subject" tick={{ fontSize: 12 }} />
            <PolarRadiusAxis angle={30} domain={[0, 100]} />
            {dataKeys.length > 0 ? (
              dataKeys.map((key, index) => (
                <Radar
                  key={key}
                  dataKey={key}
                  name={key} // name appears in the Legend
                  stroke={chartColors[index % chartColors.length]}
                  fill={chartColors[index % chartColors.length]}
                  fillOpacity={0.6}
                />
              ))
            ) : (
              <Radar
                dataKey="A"
                stroke={chartColors[0]}
                fill={chartColors[0]}
                fillOpacity={0.6}
              />
            )}
            <Tooltip
              labelFormatter={(label) => (
                <span className="tooltip-title">{label}</span>
              )}
            />
            {/* Legend to distinguish Automated vs. Manual, etc. */}
            <Legend />
          </RadarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default RadarChartComponent;
